module.exports = __webpack_public_path__ + "img/witlof-ham-kaas-met-boursin.a3c1c7e9.jpeg";